import { useMissionStore } from '../../../shared/store/useMissionStore';
import { useMissionDetailingStore } from '../../store/useMissionDetailingStore';
import Button from '@/components/Button';

export const TrainingArea = () => {
  const missionPage = useMissionDetailingStore((state) => state.missionPage);
  const mission = useMissionStore((state) => state.mission);

  if (!mission || !mission.trainingCourse) return null;

  return (
    <div className="mt-5 flex flex-col items-center justify-center rounded-2xl border border-[#9FC3FA] bg-[#F6F9FF] p-5">
      <h2 className="mb-sh-15 font-cadiz text-sh-28-32 font-bold">{missionPage?.trainingArea?.title}</h2>
      <p className="mb-sh-5 font-cadiz text-base text-gray-600">{missionPage?.trainingArea?.description}</p>
      <Button
        theme="solid-primary-600"
        size="default"
        className="mt-4"
        onClick={() => {
          window.open(`/learn/course/${mission?.trainingCourse?.slug}`, '_blank');
        }}>
        {missionPage?.trainingArea?.cta}
      </Button>
    </div>
  );
};
